import { AmbientGlow, TapeLabel } from "./_shared";

// Ported from Claude Design handoff (Direction A: SinalStats).
// 4 cards in a tight 1-gap grid, mono index top-right, giant accent stat.

const CARDS = [
  {
    stat: "0%",
    label: "de visibilidade",
    title: "Cegueira de Segurança",
    body:
      'Sua empresa tem domínios, SSL, APIs e infraestrutura em cloud. Nenhum é monitorado continuamente. Quando há um breach, a primeira notícia vem de um cliente: "vocês foram hackeados".',
    source: null as string | null,
  },
  {
    stat: "207",
    label: "dias para detectar",
    title: "Detecção Tardia",
    body:
      "O tempo médio para uma PME descobrir que foi comprometida é de 207 dias. Mais de 6 meses operando com atacantes dentro da infraestrutura, sem saber.",
    source: "SANS / Verizon DBIR",
  },
  {
    stat: "43%",
    label: "dos ataques visam PMEs",
    title: "Alvo Preferido",
    body:
      "Não é aleatório. Threat actors atacam PMEs porque sabem que não há defesa em profundidade. Empresas menores são mais fáceis de comprometer e mais lentas para reagir.",
    source: "Verizon DBIR 2024",
  },
  {
    stat: "LGPD",
    label: "multas reais desde 2024",
    title: "Compliance Não é Opcional",
    body:
      "A LGPD já está sendo enforced. Empresas que processam dados de clientes precisam provar postura de segurança. Sem evidência de monitoramento, o risco de multa é real.",
    source: null as string | null,
  },
];

export function ProblemStats() {
  return (
    <section
      id="problema"
      className="cy-section"
      style={{
        position: "relative",
        padding: "140px 40px",
        background: "var(--cy-bg)",
        borderTop: "1px solid var(--cy-ink-10)",
        overflow: "hidden",
      }}
    >
      <AmbientGlow variant="tr-bl" />
      <div
        style={{
          position: "relative",
          zIndex: 1,
          maxWidth: 1360,
          margin: "0 auto",
        }}
      >
        <div style={{ maxWidth: 760, marginBottom: 64 }}>
          <TapeLabel>O PROBLEMA</TapeLabel>
          <h2
            style={{
              fontFamily: "var(--cy-fs-sans)",
              fontSize: "clamp(36px, 4.5vw, 52px)",
              lineHeight: 1.06,
              letterSpacing: "-0.03em",
              fontWeight: 500,
              margin: "20px 0 0",
              color: "var(--cy-ink-100)",
              textWrap: "balance",
            }}
          >
            Sua empresa está vulnerável.{" "}
            <em
              style={{
                fontStyle: "italic",
                fontWeight: 300,
                color: "var(--cy-ink-60)",
              }}
            >
              Você só não sabe ainda.
            </em>
          </h2>
        </div>

        <div
          className="cy-grid-4"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: 1,
            background: "var(--cy-ink-10)",
            border: "1px solid var(--cy-ink-10)",
          }}
        >
          {CARDS.map((s, i) => (
            <div
              key={i}
              style={{
                background: "var(--cy-bg)",
                padding: "36px 28px 28px",
                position: "relative",
                minHeight: 320,
                transition: "background .2s ease",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "var(--cy-bg-elev)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "var(--cy-bg)")
              }
            >
              <div
                className="cy-mono"
                style={{
                  position: "absolute",
                  top: 16,
                  right: 16,
                  fontSize: 11,
                  color: "var(--cy-ink-40)",
                }}
              >
                0{i + 1}
              </div>
              <div
                className="cy-big-num"
                style={{
                  fontSize: 76,
                  color: "var(--cy-accent)",
                  letterSpacing: "-0.04em",
                }}
              >
                {s.stat}
              </div>
              <div
                className="cy-tape"
                style={{ marginTop: 4, marginBottom: 20 }}
              >
                {s.label}
              </div>
              <div
                style={{
                  fontFamily: "var(--cy-fs-sans)",
                  fontSize: 16,
                  fontWeight: 500,
                  color: "var(--cy-ink-100)",
                  marginBottom: 8,
                }}
              >
                {s.title}
              </div>
              <div
                style={{
                  fontSize: 13,
                  lineHeight: 1.55,
                  color: "var(--cy-ink-60)",
                }}
              >
                {s.body}
              </div>
              {s.source && (
                <div
                  className="cy-mono"
                  style={{
                    marginTop: 16,
                    fontSize: 10,
                    color: "var(--cy-ink-40)",
                    letterSpacing: "0.08em",
                  }}
                >
                  fonte · {s.source}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
